import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import {
  SetPermitTypeRoleSettings,
  SetPermitTypeRoleSettingsVariables,
} from "./__generated__/SetPermitTypeRoleSettings";
import { ORG_ROLE_FIELDS } from "../fragments/OrgRole";

const PERMIT_TYPE_ORG_ROLE_FIELDS = gql`
  ${ORG_ROLE_FIELDS}
  fragment PermitTypeOrgRoleSettingsFields on PermitTypeOrgRole {
    id
    orgRole {
      ...OrgRoleFields
    }
    settings {
      isPermitAssignee
      mandatoryOnSubmission
      shouldAuthorizePermit
      authorizationDeclaration
    }
  }
`;

const SET_PERMIT_TYPE_ROLE_SETTINGS = gql`
  ${PERMIT_TYPE_ORG_ROLE_FIELDS}
  mutation SetPermitTypeRoleSettings(
    $organizationId: String!
    $permitTypeId: String!
    $orgRoleId: String!
    $permitRoleSettingsInput: PermitRoleSettingsInput
  ) {
    setPermitTypeRoleSettings(
      input: {
        organizationId: $organizationId
        permitTypeId: $permitTypeId
        orgRoleId: $orgRoleId
        permitRoleSettingsInput: $permitRoleSettingsInput
      }
    ) {
      permitTypeOrgRole {
        ...PermitTypeOrgRoleSettingsFields
      }
    }
  }
`;

export function useSetPermitTypeRoleSettings() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    SetPermitTypeRoleSettings,
    SetPermitTypeRoleSettingsVariables
  >(SET_PERMIT_TYPE_ROLE_SETTINGS, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
